module.exports = __webpack_public_path__ + "static/track-logo-a3a244bce6c5ed58a680abacd4545845.png";